/* Avatar import map — tüm PNG'leri statik import eder, CRA bundle'a dahil eder */
import av1  from "./1anne3.png";
import av2  from "./2anne1.png";
import av3  from "./3anne2.png";
import av4  from "./4teyze.png";
import av5  from "./5nene.png";
import av6  from "./6baba5.png";
import av7  from "./7baba3.png";
import av8  from "./8baba4.png";
import av9  from "./9baba2.png";
import av10 from "./10baba1.png";
import av11 from "./11dayi.png";
import av12 from "./12amca.png";
import av13 from "./13dede.png";
import av14 from "./14cocuk2.png";
import av15 from "./15cocuk4.png";
import av16 from "./16cocuk1.png";
import av17 from "./17cocuk3.png";
import av18 from "./18bebek.png";
import av19 from "./19bebekkiz.png";
import av20 from "./20pet.png";

const AVATAR_IMPORTS = {
  "1anne3.png":   av1,
  "2anne1.png":   av2,
  "3anne2.png":   av3,
  "4teyze.png":   av4,
  "5nene.png":    av5,
  "6baba5.png":   av6,
  "7baba3.png":   av7,
  "8baba4.png":   av8,
  "9baba2.png":   av9,
  "10baba1.png":  av10,
  "11dayi.png":   av11,
  "12amca.png":   av12,
  "13dede.png":   av13,
  "14cocuk2.png": av14,
  "15cocuk4.png": av15,
  "16cocuk1.png": av16,
  "17cocuk3.png": av17,
  "18bebek.png":  av18,
  "19bebekkiz.png": av19,
  "20pet.png":    av20,
};

export default AVATAR_IMPORTS;
